<template>
  <div class="route-data-logs-component">
    <button v-if="logs.length > 0" class="btn btn-primary" @click="show = !show"><i class="fas fa-history"></i></button>
    <div v-if="show" class="log-list">
      <div v-for="log in logs" :key="log.id" class="log-item" @click="applyLog(log)">
        {{ getDate(log.created_at) }} <br>{{ getUserName(log.saved_by_user) }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import axios from 'axios';
import moment from 'moment/moment';

const startRows = ref([]);
const endRows = ref([]);
const breakRows = ref([]);

export default {
  components: {},
  props: {
    date_string: {
      type: String,
      required: true,
    },
    delivery_zone_id: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const logs = ref([]);
    const show = ref(false);

    const getDate = (date) => {
      return moment(date).format('DD/MM - YYYY HH:mm:ss');
    };

    const getUserName = (user) => {
      if (!user) {
        return 'Ukendt bruger';
      }

      return user.name || user.email || 'Ukendt bruger';
    };

    const loadLogs = () => {
      axios
        .get(`/order_management/orders/orders_data_logs?type=deliveries&date=${props.date_string}&delivery_zone=${props.delivery_zone_id}`)
        .then(response => {
          logs.value = response.data.logs;
        });
    };
    loadLogs();

    const applyLog = (log) => {
      if (props.disabled) {
        return;
      }
      emit('applyLog', log);
      show.value = false;
    };

    return {
      logs,
      show,
      getDate,
      applyLog,
      loadLogs,
      getUserName,
    };
  }
}
</script>

<style lang="scss" scoped>
.route-data-logs-component {
  position: relative;

  .log-list {
    position: absolute;
    top: 100%;
    right: 10px;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
    z-index: 100;
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;

    .log-item {
      padding: 1rem;

      &:hover {
        background-color: #f0f0f0;
        cursor: pointer;
      }
    }
  }
}
</style>